/* Away Sunday site header.
   Drives the nav dropdowns, the expanding search field (with live suggestions
   from /search/suggest.json) and the mobile drawer. The cart button is
   deliberately NOT handled here — assets/as-cart.js already claims
   [data-testid="cart-drawer-trigger"] in the capture phase and opens the
   Away Sunday cart drawer. */
(function () {
  var header = document.querySelector('[data-ash]');
  if (!header) return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- nav dropdowns --------------------------------------------------- */

  var items = Array.prototype.slice.call(header.querySelectorAll('[data-ash-item]'));

  function closeItem(item) {
    item.classList.remove('ash__item--open');
    var toggle = item.querySelector('[data-ash-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllItems(except) {
    items.forEach(function (item) {
      if (item !== except) closeItem(item);
    });
  }

  // Panels are absolutely positioned from the left edge of their trigger; flip
  // them to the right edge when that would push them off screen.
  function alignPanel(item) {
    var panel = item.querySelector('.ash__panel, .ash__drop');
    if (!panel) return;
    item.classList.remove('ash__item--align-end');
    var rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth - 12) {
      item.classList.add('ash__item--align-end');
    }
  }

  function openItem(item) {
    closeAllItems(item);
    item.classList.add('ash__item--open');
    var toggle = item.querySelector('[data-ash-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    alignPanel(item);
  }

  items.forEach(function (item) {
    var toggle = item.querySelector('[data-ash-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (item.classList.contains('ash__item--open')) closeItem(item);
      else openItem(item);
    });

    if (canHover) {
      var timer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        openItem(item);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          closeItem(item);
        }, 140);
      });
    }

    // Tabbing out of the last link in a panel should close it.
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) closeItem(item);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ash-item]')) closeAllItems(null);
  });

  /* ---- search ---------------------------------------------------------- */

  var searchToggle = header.querySelector('[data-ash-search-toggle]');
  var searchForm = header.querySelector('[data-ash-search-form]');
  var searchInput = header.querySelector('[data-ash-search-input]');
  var results = header.querySelector('[data-ash-results]');

  function setSearch(open) {
    header.classList.toggle('is-search-open', open);
    if (searchToggle) searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && searchInput) {
      // Wait a frame so the row has height before focus scrolls to it.
      window.requestAnimationFrame(function () {
        searchInput.focus();
      });
    }
    if (!open && results) {
      results.hidden = true;
      results.innerHTML = '';
    }
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      setSearch(!header.classList.contains('is-search-open'));
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllItems(null);
    if (header.classList.contains('is-search-open')) setSearch(false);
    closeDrawer();
  });

  if (searchForm && searchInput && results) {
    var currency = searchForm.dataset.currency || 'USD';
    var money;
    try {
      money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      });
    } catch (err) {
      money = null;
    }

    var debounce;
    var seq = 0;

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // Products expose a flat `image` URL; collections and pages only carry a
    // `featured_image` object. Thumbnails render at 46px, so ask the CDN for a
    // 120px-wide copy instead of the full-size original.
    function thumb(item) {
      var src = item.image || (item.featured_image && item.featured_image.url) || '';
      if (!src) return '';
      if (src.indexOf('cdn.shopify.com') !== -1 && src.indexOf('width=') === -1) {
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      }
      return src;
    }

    function row(item, meta) {
      var src = thumb(item);
      var img = src
        ? '<span class="ash__resultmedia"><img src="' +
          escapeHtml(src) +
          '" alt="" width="92" height="92" loading="lazy"></span>'
        : '<span class="ash__resultmedia"></span>';
      return (
        '<li><a class="ash__result" href="' +
        escapeHtml(item.url) +
        '">' +
        img +
        '<span class="ash__resultbody"><span class="ash__resulttitle">' +
        escapeHtml(item.title) +
        '</span>' +
        (meta ? '<span class="ash__resultmeta">' + escapeHtml(meta) + '</span>' : '') +
        '</span></a></li>'
      );
    }

    function render(data) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var pages = res.pages || [];
      var html = '';

      products.forEach(function (p) {
        var price = '';
        if (p.price != null && p.price !== '') {
          var n = parseFloat(String(p.price).replace(/[^0-9.]/g, ''));
          price = money && !isNaN(n) ? money.format(n) : String(p.price);
        }
        html += row(p, price);
      });
      collections.forEach(function (c) {
        html += row(c, 'Collection');
      });
      pages.forEach(function (p) {
        html += row(p, 'Page');
      });

      if (!html) {
        results.innerHTML = '<p class="ash__resultempty">No matches. Press Search to look again.</p>';
      } else {
        results.innerHTML = '<ul class="ash__resultlist" role="list">' + html + '</ul>';
      }
      results.hidden = false;
    }

    function suggest(term) {
      var mine = ++seq;
      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=5' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          if (mine !== seq || !data) return;
          render(data);
        })
        .catch(function () {
          /* non-fatal — the form still submits to /search */
        });
    }

    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(debounce);
      if (term.length < 2) {
        seq++;
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      debounce = setTimeout(function () {
        suggest(term);
      }, 180);
    });

    searchForm.addEventListener('submit', function (e) {
      if (!searchInput.value.trim()) e.preventDefault();
    });
  }

  /* ---- mobile drawer --------------------------------------------------- */

  var drawer = document.querySelector('[data-ash-drawer]');
  var drawerOpen = header.querySelector('[data-ash-drawer-open]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ash-lock');
    if (drawerOpen) drawerOpen.setAttribute('aria-expanded', 'true');
    // Focus the close button, not the first link — focusing the wordmark link
    // paints a focus ring around the logo the moment the drawer opens.
    var close = drawer.querySelector('[data-ash-drawer-close]:not(.ash-drawer__scrim)');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ash-lock');
    if (drawerOpen) {
      drawerOpen.setAttribute('aria-expanded', 'false');
      drawerOpen.focus();
    }
  }

  if (drawerOpen) drawerOpen.addEventListener('click', openDrawer);

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      // Close on the scrim, the X, and on any navigation out of the drawer.
      if (e.target.closest('[data-ash-drawer-close]') || e.target.closest('a')) closeDrawer();
    });

    // "View bag" inside the drawer is a cart trigger, and as-cart.js claims
    // those on document/capture with stopImmediatePropagation — which never
    // lets the bubble-phase listener above run. Without this the menu would
    // stay open behind the cart drawer and leave `ash-lock` on <body>, so the
    // page can't scroll once the cart drawer is dismissed. This listener is
    // also on document/capture and as-shell.js is ordered before as-cart.js,
    // so it fires first.
    document.addEventListener(
      'click',
      function (e) {
        var trigger = e.target.closest('[data-testid="cart-drawer-trigger"], a[href$="/cart"]');
        if (trigger && drawer.contains(trigger)) closeDrawer();
      },
      true
    );
  }

  // Anything above the mobile breakpoint uses the inline nav, so a drawer left
  // open across a resize would trap scroll behind an invisible panel.
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) closeDrawer();
  });
})();
